var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaneGoing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 30,
    viewBox: "0 0 28 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "partida-de-aviao",
    d: "M.848,15.494,2.923,16.97a5.655,5.655,0,0,0,5.708.5l13.932-6.677a2.533,2.533,0,0,0,1.2-3.338,2.506,2.506,0,0,0-3.319-1.219l-.007,0-4,1.932-.031-.022L9.185,3.492a2.5,2.5,0,0,0-2.542-.26L5.862,3.6A1.5,1.5,0,0,0,5.5,6.078l5.346,4.785L5.79,13.305,2.552,12.116a1.92,1.92,0,0,0-2.17.629,1.82,1.82,0,0,0-.361,1.4,2.022,2.022,0,0,0,.828,1.352ZM6.169,5.332a.5.5,0,0,1-.164-.446A.488.488,0,0,1,6.287,4.5l.778-.365a1.507,1.507,0,0,1,1.55.174l6.769,4.362-3.561,1.719Zm-5,8.028A.931.931,0,0,1,1.9,13a.9.9,0,0,1,.309.056l3.437,1.262a.5.5,0,0,0,.39-.02l14.837-7.16a1.5,1.5,0,0,1,1.989.732,1.53,1.53,0,0,1-.728,2.016L8.2,16.563a4.657,4.657,0,0,1-4.7-.407L1.428,14.68A1.02,1.02,0,0,1,1.011,14a.83.83,0,0,1,.16-.638ZM24,23.5a.5.5,0,0,1-.5.5H.5a.5.5,0,0,1,0-1h23A.5.5,0,0,1,24,23.5Z",
    transform: "translate(0 -3)",
    fill: "#35bde8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneGoing);
export default __webpack_public_path__ + "static/media/plane-going.0c18461aabf19038242c6b913ed5e1a9.svg";
export { ForwardRef as ReactComponent };